import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  /* Fix 2026-07-04: sin padding horizontal — el botón Iniciar queda alineado
     con el borde derecho de las cards/mapa. */
  padding: ${({ theme }) => theme.spacing.l} 0;
`;
